import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[siqDynamicComponentHost]'
})
export class DynamicComponentHostDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
